import { ChevronDown, LayoutGrid, Paperclip, PenTool, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProjectSectionHeader } from "@/components/projects";
import { useAuth } from "@/hooks/useAuth";
import { Permissions } from "@/lib/permissions";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui";
import { MenuBookIcon } from "@/components/icons";

interface ContextHeaderProps {
  projectId: string;
  setFilesDialogOpen: (open: boolean) => void;
  setReposDialogOpen: (open: boolean) => void;
  setWikiDialogOpen: (open: boolean) => void;
}

export function ContextHeader({ projectId, setFilesDialogOpen, setReposDialogOpen, setWikiDialogOpen }: ContextHeaderProps) {
  const { hasPermission } = useAuth(projectId);
  const canCreate = hasPermission(Permissions.Project.Context.Create, projectId);

  return (
    <ProjectSectionHeader sectionName="Context">
      {canCreate && (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button>
                    <Plus className="h-4 w-4" />
                    New Context
                    <ChevronDown className="ml-2 h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" side="top">
                <DropdownMenuItem onClick={() => setFilesDialogOpen(true)}>
                    <Paperclip className="mr-2 h-4 w-4" />
                        Files
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setReposDialogOpen(true)}>
                    <LayoutGrid className="mr-2 h-4 w-4" />
                        Repositories
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setWikiDialogOpen(true)}>
                    <MenuBookIcon className="mr-2 h-4 w-4" />
                        Wiki Pages
                </DropdownMenuItem>
                <DropdownMenuItem disabled>
                    <PenTool className="mr-2 h-4 w-4" />
                        Figma Files
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )}
    </ProjectSectionHeader>
  );
}
